import { compose } from 'recompose';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import StopImagesDialog from '../../../Dispatch/RouteExecution/DriverPopUp/StopImagesDialog';
import { withStyles } from '@material-ui/core';
import { withAppConfig } from '../../../../../appConfigContext';
import { getProNumbers } from '../../../Dispatch/RouteExecution/DriverPopUp/utils';
const styles = (theme) => ({
  imageStyle: {
    height: '100%',
    border: `1px solid ${theme.AppBGColor}`
  }
});
const StopImages = (props) => {
  const proNumbers = getProNumbers(props.stopData.shipments);
  return (
    <div className={props.classes.imageStyle}>
      <StopImagesDialog
        showImages={proNumbers[0] || 'signature'}
        withDialog={false}
        terminalCode={props.route.terminalCode}
        routeId={props.route.routeId}
        stopId={props.stopData.stopId}
        isStopCompleted={props.stopData.isStopCompleted}
        proNumbers={proNumbers}
        stops={props.route.stops.map((stop) => {
          return { ...stop, ...stop.consigneeDetails };
        })}
        apiName={props.route.isLiveDispatch ? 'GetImages' : 'StopImages'}
        close={null}
        key={props.stopData.stopId}
        hideHeaderActions={true}
        enablePublishDeliveryReceiptFromReport={
          props.configJSON.enablePublishDeliveryReceiptFromReport
        }
      />
    </div>
  );
};

export default compose(withStyles(styles), withUserProfile, withAppConfig)(StopImages);
